module.exports = __webpack_public_path__ + "img/girl-and-boy.289732c.svg";